import React from 'react';
import {ThemeProvider} from 'styled-components';
import PropTypes from 'prop-types';
import {theme} from 'web-components';

/*
 * Duplicated this here from web-components. The ThemeProvider was not working otherwise
 * Most likely because we run into multiple instances of Styled Components - tried to fix it
 * but ran out of time. This seems like a better workaround than hardcoding theme values at least.
 * */

export const ForecastThemeProvider = ({children}) => {
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

ForecastThemeProvider.propTypes = {
	children: PropTypes.any,
};
